<template>
  <div>
    <Title :pages="[{ icon: 'user-tie', page: page_title.toUpperCase() }]"></Title>

    <v-container fluid>
      <Modal
        v-if="create_access"
        :button_name="'Crear ' + modal_title"
        :modal_title="modal_title"
        :page_title="page_title"
        :formBtn="formBtn"
        :dialog="dialog"
        :service="service"
        @updateDialog="updateDialog"
        @loadList="loadList(service)"
        :editItem="mainItem"
      />

      <ApiCredentialsModal :dialog="dialog_api" :service="service" :editItem="mainItem" @updateDialog="updateDialogApi" @loadList="loadList(service)" />

      <v-card v-if="list_access">
        <v-card-title>
          <v-row align="center" class="mt-1">
            <v-col>
              <span>{{ page_title }}</span>
            </v-col>
            <v-spacer></v-spacer>
            <v-col>
              <v-text-field v-model="search" append-inner-icon="mdi-magnify" single-line hide-details label="Buscar" density="compact"></v-text-field>
            </v-col>
          </v-row>
        </v-card-title>

        <v-data-table :headers="headers" :items="list" :search="search" :loading="loading" loading-text="Cargando...">
          <template v-slot:item="{ item }">
            <tr>
              <td>{{ item.name }}</td>
              <td>{{ item.user.username }}</td>
              <td>{{ item.cuit }}</td>
              <td>{{ item.mail }}</td>
              <td>{{ item.phone }}</td>
              <td>{{ item.code_external_reference }}</td>
              <td>{{ item.address + ", " + item.location }}</td>
              <td class="text-center">{{ item.user.enable ? "Si" : "No" }}</td>
              <td class="text-center" style="min-width: 150px">
                <v-tooltip bottom>
                  <template v-slot:activator="{ props }">
                    <v-icon v-if="update_access" v-bind="props" small color="blue" class="mr-2" v-on:click="editItem(item)" size="small"> mdi-pencil</v-icon>
                  </template>
                  <span>Editar</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ props }">
                    <v-icon v-bind="props" small color="blue" class="mr-2" v-on:click="viewItem(item)" size="small"> mdi-eye </v-icon>
                  </template>
                  <span>Ver</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ props }">
                    <v-icon v-if="sensible_access" v-bind="props" small color="green" class="mr-2" v-on:click="openApiCredentials(item)" size="small">mdi-key-variant</v-icon>
                  </template>
                  <span>Credenciales API</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ props }">
                    <v-icon v-if="delete_access" v-bind="props" small color="red" class="mr-2" v-on:click="deleteItem(item)" size="small">mdi-delete </v-icon>
                  </template>
                  <span>Eliminar</span>
                </v-tooltip>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>

      <DialogDelete :dialog_delete="dialog_delete" @updateDialogDelete="updateDialogDelete" @deleteItemConfirm="deleteItemConfirm" :loading="loadingSubmit" />
    </v-container>
  </div>
</template>

<script>
import { clientService } from "@/libs/ws/clientService";
import GenericMixin from "@/mixins/GenericMixin.vue";
import RolMixin from "@/mixins/RolMixin.vue";
import Modal from "./Modal.vue";
import ApiCredentialsModal from "./ApiCredentialsModal.vue";

export default {
  components: { Modal, ApiCredentialsModal },
  mixins: [GenericMixin, RolMixin],
  RolMixin,
  data() {
    return {
      service: clientService,
      dialog_api: false,
      page_title: "Clientes",
      modal_title: "Cliente",
      headers: [
        {
          title: "Nombre",
          align: "left",
          sortable: true,
          key: "name",
        },
        {
          title: "Usuario",
          align: "left",
          sortable: true,
          key: "user.username",
        },
        {
          title: "CUIT",
          align: "left",
          sortable: true,
          key: "cuit",
        },
        {
          title: "Email",
          align: "left",
          sortable: true,
          key: "mail",
        },
        {
          title: "Telefono",
          align: "left",
          sortable: true,
          key: "phone",
        },
        {
          title: "Codigo de Referencia Externa",
          align: "left",
          sortable: true,
          key: "code_external_reference",
        },
        {
          title: "Direccion",
          align: "left",
          sortable: true,
          key: "address",
        },
        {
          title: "Habilitado",
          align: "center",
          sortable: true,
          key: "enable",
        },
        { title: "Accion", align: "center", sortable: false, key: "" },
      ],
    };
  },
  mounted() {
    this.loadList(this.service);
  },
  methods: {
    getFilterParams() {
      // La tabla pagina del lado del cliente: se pide el listado completo
      return { limit: 0 };
    },
    openApiCredentials(item) {
      this.mainItem = item;
      this.dialog_api = true;
    },
    updateDialogApi(value) {
      this.dialog_api = value;
    },
  },
};
</script>
